export default __webpack_public_path__ + "static/media/wire-transfer.11f626e2.png";